// extracted by mini-css-extract-plugin
export default {"bleed":"HorizontalScroll_bleed__auDCS","scroll":"HorizontalScroll_scroll__OaMjU","wide":"HorizontalScroll_wide__SqzHQ","member":"HorizontalScroll_member__g7Enx"};